var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Essentional, UI / Flag 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.57031C5.41421 1.57031 5.75 1.9061 5.75 2.32031V3.40546L7.32358 3.09074C9.11678 2.7321 10.9756 2.90276 12.6735 3.58193L13.0868 3.74724C14.3652 4.25864 15.7724 4.35414 17.1082 4.02017C18.3875 3.70037 19.4147 5.08683 18.7363 6.2175L17.4578 8.3484C17.0814 8.97573 17.021 9.10514 17.0056 9.22306C16.9972 9.28762 16.9972 9.35301 17.0056 9.41757C17.021 9.53549 17.0814 9.66489 17.4578 10.2922L19.0184 12.8933C19.5884 13.8432 19.0787 15.0737 18.004 15.3424L17.9039 15.3674C15.9814 15.848 13.9563 15.7106 12.1164 14.9746C10.6886 14.4035 9.12562 14.26 7.61776 14.5616L5.75 14.9352V22.3203C5.75 22.7345 5.41421 23.0703 5 23.0703C4.58579 23.0703 4.25 22.7345 4.25 22.3203V2.32031C4.25 1.9061 4.58579 1.57031 5 1.57031ZM5.75 13.4055L7.32358 13.0907C9.11678 12.7321 10.9756 12.9028 12.6735 13.5819C14.2206 14.2008 15.9235 14.3164 17.5401 13.9122L17.6402 13.8872C17.7377 13.8628 17.7839 13.7512 17.7322 13.6651L16.1716 11.064C16.1517 11.031 16.132 10.9982 16.1125 10.9658C15.8295 10.4959 15.5796 10.0809 15.5183 9.61207C15.493 9.41839 15.493 9.22223 15.5183 9.02855C15.5796 8.55977 15.8295 8.14472 16.1125 7.67486C16.132 7.6424 16.1517 7.60967 16.1716 7.57665L17.4254 5.4869C15.7976 5.88356 14.0861 5.76251 12.5297 5.13996L12.1164 4.97464C10.6886 4.40355 9.12562 4.26004 7.61776 4.56161L5.75 4.93517V13.4055Z",
    fill: "#4B4B4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.3913eee3588db1c9e5f8c1c9585fd79c.svg";
export { ForwardRef as ReactComponent };